import { Body, Box, Icon, Link } from "@biom3/react";

export function NotEnoughGemsMessage() {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-start",
        gap: "base.spacing.x2",
        width: "100%",
        maxWidth: "350px",
        marginTop: "base.spacing.x1",
      }}
    >
      <Icon
        icon="InformationCircle"
        variant="bold"
        sx={{
          marginTop: "base.spacing.x1",
          width: "base.icon.size.300",
          aspectRatio: "1/1",
          fill: "base.color.status.guidance.bright",
        }}
      />
      <Body size="small">
        You don’t have enough gems to get a key. Claim more gems by completing
        quests.{" "}
        <Link
          variant="primary"
          rc={<a href="/" target="_blank" rel="noopener noreferrer" />}
        >
          Do more quests
        </Link>
      </Body>
    </Box>
  );
}
